/* eslint-disable react/display-name */
import { lazy } from "react";

const FlashScannerBarCodeLogPage = lazy(() => import("./pages/barcode-logs"));
const FlashScannerLogsPage = lazy(() => import("./pages/logs"));
const FlashScannerManagePage = lazy(() => import("./pages/scanner-manage"));
const FlashScannerInboundLogPage = lazy(
  () => import("./pages/logs/InboundLogs")
);
const FlashScannerOutboundLogPage = lazy(
  () => import("./pages/logs/OutboundLogs")
);
const ScannerLogsPage = lazy(() => import("./pages/scanner-logs"));

const FlashScannerPackagePage = lazy(
  () => import("../wms/pages/flash-scanner/package")
);
const FlashScannerBagPage = lazy(
  () => import("../wms/pages/flash-scanner/bag")
);
const FlashScannerWMSLogsPage = lazy(
  () => import("../wms/pages/flash-scanner/logs")
);

const FlashScannerRoutes = [
  { path: "barcode-log", element: <FlashScannerBarCodeLogPage /> },
  { path: "logs", element: <FlashScannerLogsPage /> },
  { path: "scanner", element: <FlashScannerManagePage /> },
  { path: "inbound-logs", element: <FlashScannerInboundLogPage /> },
  { path: "outbound-logs", element: <FlashScannerOutboundLogPage /> },
  { path: "scanner-logs", element: <ScannerLogsPage /> },

  { path: "package", element: <FlashScannerPackagePage /> },
  { path: "bag", element: <FlashScannerBagPage /> },
  { path: "wms-logs", element: <FlashScannerWMSLogsPage /> }
];
export default FlashScannerRoutes;
